import { render, staticRenderFns } from "./DashboardTextResult.vue?vue&type=template&id=75a505a5&"
import script from "./DashboardTextResult.vue?vue&type=script&lang=js&"
export * from "./DashboardTextResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports